import AddToRole from './addToRole';
import ConfirmUserEmail from './confirmUserEmail';
import ExcludeFromAnalysis from './excludeFromAnalysis';
import ResetUserPassword from './resetUserPassword';
import UsersData from './usersData';

const Admin = () => {
    return (
        <>
            <h1>Admin area</h1>
            <AddToRole />
            <ResetUserPassword />
            <ConfirmUserEmail />
            <ExcludeFromAnalysis />
            <UsersData />
        </>
    );
};

export default Admin;
